import { render, staticRenderFns } from "./PriceLists.vue?vue&type=template&id=773214b0&scoped=true"
import script from "./PriceLists.vue?vue&type=script&lang=js"
export * from "./PriceLists.vue?vue&type=script&lang=js"
import style0 from "./PriceLists.vue?vue&type=style&index=0&id=773214b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773214b0",
  null
  
)

export default component.exports